import { IconPropType } from ".";

export const PlusIcon: React.FC<IconPropType> = ({ width = 20, height = 20, className = '' }) => (
  <svg xmlns="http://www.w3.org/2000/svg" width={width} height={height} viewBox="0 0 20 20" fill="none">
  <path d="M10 2C10.2455 2 10.4496 2.17688 10.4919 2.41012L10.5 2.5V9.5H17.5C17.7761 9.5 18 9.72386 18 10C18 10.2455 17.8231 10.4496 17.5899 10.4919L17.5 10.5H10.5V17.5C10.5 17.7761 10.2761 18 10 18C9.75454 18 9.55039 17.8231 9.50806 17.5899L9.5 17.5V10.5H2.5C2.22386 10.5 2 10.2761 2 10C2 9.75454 2.17688 9.55039 2.41012 9.50806L2.5 9.5H9.5V2.5C9.5 2.22386 9.72386 2 10 2Z" fill="currentColor"/>
</svg>
);

